module.exports = __webpack_public_path__ + "static/img/pinpai-16.fd9f5e85.png";